import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as hero from './scripts/hero';
hero.init();

import * as segment from './scripts/segment';
segment.init();

import * as factArea from './scripts/fact-area';
factArea.init();

import * as logoSlider from './scripts/logo-slider';
logoSlider.init();

import * as solutionArea from './scripts/solution-area';
solutionArea.init();

// Content-teaser-slider
import * as genericSlider from './scripts/generic-slider';
genericSlider.init();

// Image Row
import * as imageRow from './scripts/image-row';
imageRow.init();

// Bildergalerie
import * as imageGallerySlider from './scripts/image-gallery-slider';
imageGallerySlider.init();

// Photo Grid
import * as photoGrid from './scripts/photo-grid';
photoGrid.init();

// Referenc Slider
import * as teaserSliderLg from './scripts/teaser-slider-lg';
teaserSliderLg.init();

import * as tabs from './scripts/tabs';
tabs.init();

import * as accordion from './scripts/accordion.js';
accordion.init();

//bootstrap imports
import Collapse from 'bootstrap/js/dist/collapse';